import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';
import Books from './Books';

const LightGreenSpinner = styled(CircularProgress)({
  color: '#66bb6a',
  filter: 'drop-shadow(0 0 6px #66bb6a)',
});

const Offerings = () => {
  const { book } = useParams(); // Get the 'book' parameter from the URL
  const [data, setData] = useState(null); // State to store fetched data
  const [loading, setLoading] = useState(true); // State to handle loading state
  const [error, setError] = useState(null); // State to handle errors

  // Fetch data from the API
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/weoffer`);
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const result = await response.json();
        // Preprocess the data: Remove spaces and convert courseName to lowercase
        const processedData = result.map((item) => ({
          ...item,
          key: item.courseName.replace(/\s+/g, '').toLowerCase(), // Create a key for matching
        }));

        setData(processedData); // Set the processed data
      } catch (error) {
        setError(error.message); // Set error message if something goes wrong
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchData();
  }, []); // Empty dependency array ensures this runs only once on mount

  // Render different content based on the book parameter
  let content;
  if (loading) {
    content = (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="300px"
      >
        <LightGreenSpinner size={50} thickness={5} />
        <br />
        <Typography variant="h6" ml={2}>
          Loading...
        </Typography>
      </Box>
    );
    content = <div>Loading...</div>; // Show loading message while fetching data
  } else if (error) {
    content = <div>Error: {error}</div>; // Show error message if something went wrong
  } else if (data) {
    // Find the matching book data based on the URL parameter
    const matchedBook = data.find((item) => {
      return item.key === book
    });
    if (matchedBook) {
      const processedLongDescription = matchedBook.longDescription?.replaceAll('{index}', matchedBook.index);
      matchedBook.longDescription = processedLongDescription;

      content = (
        <Books
          data={matchedBook}
          // teacher={['opencs', 'davincilab', 'stepup'].includes(matchedBook.key)}
          teacher={data.find((item) => {
            return item.type !== 'book' && item.key === book
          })}
        />
      );
    } else {
      content = <div>Book not found</div>; // Handle case where no matching book is found
    }
  }

  return <>{content}</>;
};

export default Offerings;
